import React, { createContext, useState } from "react";
import { useGet } from "restful-react";

import {
  getMe,
  getMyTeams,
  IUser,
  IUserResponse,
  ITeam,
  ITeamsResponse,
} from "apis";
import {
  getDefaultTeam,
  setDefaultTeam as setDefaultTeamLocally,
} from "utils/localStorage";

import { IUserContext } from "./types";

interface IUserProviderProps {
  children: React.ReactNode;
}

// @ts-ignore
export const UserContext = createContext<IUserContext>();

export const UserProvider = ({ children }: IUserProviderProps) => {
  const [me, setMe] = useState<IUser | undefined>(undefined);
  const [defaultTeam, setDefaultTeam] = useState<number>(getDefaultTeam());
  const [teams, setTeams] = useState<ITeam[]>([]);

  const handleGetMe = (data: IUserResponse) => {
    setMe(data && data.user);
  };

  const handleGetMyTeams = (data: ITeamsResponse) => {
    setTeams(data?.teams || []);

    if (data?.teams?.length) {
      setDefaultTeam(data.teams[0].id);
      setDefaultTeamLocally(data.teams[0].id);
    }
  };

  useGet({
    path: getMe(),
    resolve: handleGetMe,
  });

  useGet({
    path: getMyTeams(),
    resolve: handleGetMyTeams,
  });

  const onSetMe = (me: IUser) => {
    setMe(me);
  };

  const onSetTeams = (teams: ITeam[]) => {
    setTeams(teams);
  };

  const onSetDefaultTeam = (teamId: number) => {
    setDefaultTeam(teamId);
  };

  return me ? (
    <UserContext.Provider
      value={{
        me,
        setMe: onSetMe,
        teams,
        setTeams: onSetTeams,
        defaultTeam,
        setDefaultTeam: onSetDefaultTeam,
      }}
    >
      {children}
    </UserContext.Provider>
  ) : null;
};
